export const POST_IMAGE_S3_WATCHER = 'POST_IMAGE_S3_WATCHER';
export const POST_IMAGE_S3_SUCCESS = 'POST_IMAGE_S3_SUCCESS';
export const POST_IMAGE_S3_FAILED = 'POST_IMAGE_S3_FAILED';
